import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const SalesPortalUpdateEmployeeNotificationsDocument = gql`
  mutation SalesPortalUpdateEmployeeNotifications(
    $employeeContactInfoUUID: uuid!
    $set: employee_contact_info_set_input!
  ) {
    update_employee_contact_info_by_pk(
      pk_columns: { uuid: $employeeContactInfoUUID }
      _set: $set
    ) {
      uuid
      wants_chat_email
      wants_credit_request_email
      wants_order_email
      wants_order_tracking_notification
      wants_payment_email
    }
  }
`;
export type SalesPortalUpdateEmployeeNotificationsMutationFn =
  Apollo.MutationFunction<
    Types.SalesPortalUpdateEmployeeNotificationsMutation,
    Types.SalesPortalUpdateEmployeeNotificationsMutationVariables
  >;
export function useSalesPortalUpdateEmployeeNotificationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SalesPortalUpdateEmployeeNotificationsMutation,
    Types.SalesPortalUpdateEmployeeNotificationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SalesPortalUpdateEmployeeNotificationsMutation,
    Types.SalesPortalUpdateEmployeeNotificationsMutationVariables
  >(SalesPortalUpdateEmployeeNotificationsDocument, options);
}
export type SalesPortalUpdateEmployeeNotificationsMutationHookResult =
  ReturnType<typeof useSalesPortalUpdateEmployeeNotificationsMutation>;
export type SalesPortalUpdateEmployeeNotificationsMutationResult =
  Apollo.MutationResult<Types.SalesPortalUpdateEmployeeNotificationsMutation>;
export type SalesPortalUpdateEmployeeNotificationsMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SalesPortalUpdateEmployeeNotificationsMutation,
    Types.SalesPortalUpdateEmployeeNotificationsMutationVariables
  >;
